import { useState, useEffect } from "react";
import aniimage1 from "../../../assets/icons/icon_box_ dynamic.png";
import aniimage2 from "../../../assets/icons/icon_home_dynamic.png";
import aniimage3 from "../../../assets/icons/icon_love_dynamic.png";

const useSloganPart = () => {
  const items = [
    {
      icon: aniimage1,
      text: "Good design doesn’t ask for attention; it earns it.",
    },
    {
      icon: aniimage2,
      text: "Every corner deserves a little love.",
    },
    {
      icon: aniimage3,
      text: "Home isn’t built; it’s curated.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);

      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % items.length);
      }, 300);

      setTimeout(() => {
        setFade(false);
      }, 600);
    }, 5000);

    return () => clearInterval(interval);
  }, [items.length]);

  return {
    items,
    currentIndex,
    fade,
  };
};

export default useSloganPart;
